import React, { useContext } from "react";
import { TeamTabNavigationProp } from "../TeamTab";
import { TeamScheduleScreen } from "./TeamSchedule/TeamSchedule";

import { TeamHomeStack } from "./TeamHomeStack";

import { TeamNavigatorContext } from "../TeamNavigatorContext";
import { TeamHeaderComponent } from "./TeamHome/TeamHeader/TeamHeader";
import { graphql, useFragment } from "react-relay";

import { TeamScheduleNavigationHeader } from "./TeamScheduleHeader";

import { Team } from "./Team/Team";

import { TeamHomeNavigator_store$key } from "./__generated__/TeamHomeNavigator_store.graphql";
import { TeamHomeNavigator_home$key } from "./__generated__/TeamHomeNavigator_home.graphql";
import { TeamHomeNavigator_storeViewer$key } from "./__generated__/TeamHomeNavigator_storeViewer.graphql";
type Props = {
  navigation: TeamTabNavigationProp<"TeamHome">;
  home: TeamHomeNavigator_home$key;
  storeViewer: TeamHomeNavigator_storeViewer$key;
  store: TeamHomeNavigator_store$key;
};

export const TeamHomeNavigator = React.memo(TeamHomeNavigatorC);
function TeamHomeNavigatorC(props: Props) {
  const teamId = useContext(TeamNavigatorContext).teamId;

  const home = useFragment(
    graphql`
      fragment TeamHomeNavigator_home on HomeUnion {
        ...TeamHeader_home
      }
    `,
    props.home
  );

  const store = useFragment(
    graphql`
      fragment TeamHomeNavigator_store on Store {
        ...TeamScheduleHeader_store
        ...TeamHeader_store
        team(id: $id) {
          ...TeamHeader_team
          ...TeamScheduleHeader_team
        }
      }
    `,
    props.store
  );

  const storeViewer = useFragment(
    graphql`
      fragment TeamHomeNavigator_storeViewer on StoreViewer {
        ...TeamHeader_storeViewer
      }
    `,
    props.storeViewer
  );
  const team = store.team;

  return (
    <TeamHomeStack.Navigator>
      <TeamHomeStack.Screen
        name="TeamHomeMain"
        component={Team}
        initialParams={{
          teamId,
        }}
        options={{
          header: () =>
            home && store.team ? (
              <TeamHeaderComponent
                home={home}
                navigation={props.navigation}
                team={store.team}
                store={store}
                storeViewer={storeViewer}
              />
            ) : null,
        }}
      />
      <TeamHomeStack.Screen
        name="TeamSchedule"
        component={TeamScheduleScreen}
        initialParams={{ teamId }}
        options={(p) => ({
          headerShown: true,
          header: () =>
            team ? (
              <TeamScheduleNavigationHeader
                team={team}
                store={store}
                onPressBack={() => p.navigation.goBack()}
                onPressAdmin={(teamId) =>
                  props.navigation.navigate("TeamScheduleAdmin", {
                    teamId,
                  })
                }
                onPressSupport={(teamId) =>
                  props.navigation.navigate("SupportTeamSchedule", {
                    teamId,
                  })
                }
              />
            ) : null,
        })}
      />
    </TeamHomeStack.Navigator>
  );
}
